import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=e43baeee&scoped=true&lang=pug&"
import script from "./PrimaryButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43baeee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e43baeee')) {
      api.createRecord('e43baeee', component.options)
    } else {
      api.reload('e43baeee', component.options)
    }
    module.hot.accept("./PrimaryButton.vue?vue&type=template&id=e43baeee&scoped=true&lang=pug&", function () {
      api.rerender('e43baeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/buttons/PrimaryButton.vue"
export default component.exports